import * as React from 'react';
import Box from '@mui/material/Box';
import {useEffect, useRef} from "react";


export default function Download({file}) {
    const link = useRef();

    useEffect(() => {
       link.current.click();
    })

  return (
     <Box>
         <a ref={link} href={file} ></a>
     </Box>
  );
}
